var map = {
	"./about-company-overview.jpg": 2680,
	"./background1.jpg": 1242,
	"./background11.jpg": 6901,
	"./blog1.jpg": 6818,
	"./blog2.jpg": 2749,
	"./capacitors-harmonics-reactive-power/capacitor-bank.jpg": 3879,
	"./industries/data-centers.jpg": 4183,
	"./industries/industrial.jpg": 1647,
	"./industries/renewables.jpg": 8832,
	"./industries/utilities.jpg": 736,
	"./load-shedding-power-management/control-room.jpg": 3106,
	"./our-services.jpg": 1068,
	"./poi-interconnection-studies/application-support.jpg": 3303,
	"./poi-interconnection-studies/emt-weak-grid.png": 603,
	"./poi-interconnection-studies/load-flow-short-circuit.jpg": 1857,
	"./poi-interconnection-studies/poi-interconnection.jpg": 7310,
	"./poi-interconnection-studies/protection-commissioning.jpg": 7160,
	"./poi-interconnection-studies/reactive-power.jpg": 1214,
	"./poi-interconnection-studies/transient-stability.jpg": 9055,
	"./power-system-automation/control-design.jpg": 3057,
	"./power-system-automation/controls-integration.jpg": 8408,
	"./power-system-automation/hmi-scada.jpg": 7560,
	"./power-system-automation/microgrid.jpg": 7687,
	"./power-system-automation/modernization.jpg": 800,
	"./power-system-automation/plc-programming.jpg": 448,
	"./power-system-automation/remote-monitoring.jpg": 3670,
	"./power-system-automation/rtac-programming.jpg": 1769,
	"./power-system-data-analytics/power-metering.jpg": 524,
	"./power-system-studies/arc-flash.jpg": 2640,
	"./power-system-studies/grounding.jpg": 694,
	"./power-system-studies/harmonics.jpg": 265,
	"./power-system-studies/load-flow.jpg": 4928,
	"./power-system-studies/modeling.jpg": 2252,
	"./power-system-studies/motor-starting.jpg": 681,
	"./power-system-studies/power-system-studies.jpg": 4234,
	"./power-system-studies/protection-evaluation.jpg": 1521,
	"./power-system-studies/relay-coordination.jpg": 6604,
	"./power-system-studies/short-circuit.jpg": 1717,
	"./project1.jpg": 6943,
	"./project2.jpg": 9568,
	"./protection-relay-programming/bus-protection.jpg": 3885,
	"./protection-relay-programming/custom-logic.jpg": 1111,
	"./protection-relay-programming/feeder-protection.jpg": 2672,
	"./protection-relay-programming/generator-protection.jpg": 2546,
	"./protection-relay-programming/line-protection.jpg": 9793,
	"./protection-relay-programming/motor-protection.jpg": 822,
	"./protection-relay-programming/protection-relays.jpg": 5223,
	"./protection-relay-programming/transfer-schemes.jpg": 3037,
	"./protection-relay-programming/transformer-protection.jpg": 1440,
	"./service1.jpg": 553,
	"./service1.png": 5777,
	"./service2.jpg": 958,
	"./service3.jpg": 5915,
	"./service5.jpg": 8293,
	"./service5.png": 2117,
	"./service6.png": 4766,
	"./tppesLogo2.JPG": 4037,
	"./tppesLogo3.jpg": 4911,
	"./xyz.svg": 7500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;